import React, { useEffect, useMemo, useState } from "react";
import LayoutNew from "../components/shared/LayoutNew";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { apiGet, mediaUrl } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import moment from "moment";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const depositKeys = [
  "OnFirstDeposit",
  "OnSecondDeposit",
  "OnThirdDeposit",
  "OneFourthDeposit",
];

const Promotions = () => {
  const [data, setData] = useState([]);
  const [tab, setTab] = useState("All");
  const [openId, setOpenId] = useState("");
  const navigate = useNavigate();
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);

  useEffect(() => {
    let active = true;
    (async () => {
      const { status, data: payload } = await apiGet(apiPath.getPromotional);
      if (!active || status !== 200 || !payload?.success) {
        return;
      }
      const list = payload?.results?.offerList || [];
      const deposited = Number(profileData?.userDepositCount) || 0;
      const hide = depositKeys.slice(0, deposited);
      setData(list.filter((offer) => !hide.includes(offer.offerOn)));
    })();
    return () => {
      active = false;
    };
  }, [profileData]);

  const tabs = useMemo(() => {
    const cats = [...new Set(data.map((item) => item?.category).filter(Boolean))];
    return ["All", ...cats];
  }, [data]);

  const visible = useMemo(
    () => (tab === "All" ? data : data.filter((item) => item?.category === tab)),
    [data, tab],
  );

  return (
    <LayoutNew>
      <div className="activity-preview-bg">
        <div className="page-title">
          <span>Promotion</span>
        </div>
        <div className="promo-tabs">
          {tabs.map((name) => (
            <button
              key={name}
              type="button"
              className={tab === name ? "active" : ""}
              onClick={() => setTab(name)}
            >
              {name}
            </button>
          ))}
        </div>
        <div className="activity-content">
          <div className="promo-list">
            {visible.map((res) => {
              const banner = mediaUrl(res?.offerImage || res?.descriptionImage);
              const detail = mediaUrl(res?.descriptionImage || res?.offerImage);
              const opened = openId === res?._id;
              return (
                <div className="promo-item" key={res?._id || res?.title}>
                  <div className="promo-item-bg">
                    <div className="activity-img">
                      {banner ? (
                        <img src={banner} alt={res?.title || "Promotion"} />
                      ) : null}
                    </div>
                    <div className="activity-info">
                      <div className="title">
                        <span>{res?.title}</span>
                      </div>
                      <div className="promo-actions">
                        <button
                          type="button"
                          className="view-all"
                          onClick={() => setOpenId(opened ? "" : res?._id)}
                        >
                          {opened ? "Hide" : "View"}
                        </button>
                        {!isEmpty(user) && (
                          <button
                            type="button"
                            className="view-all"
                            onClick={() => navigate(`/deposit/${res?._id}`)}
                          >
                            Deposit
                          </button>
                        )}
                      </div>
                    </div>
                    {opened && (
                      <div className="offer-content">
                        {res?.offerStartDateTime && res?.offerEndDateTime && (
                          <p className="offer-dates">
                            {moment(res.offerStartDateTime).format("YYYY/MM/DD")}
                            {" - "}
                            {moment(res.offerEndDateTime).format("YYYY/MM/DD")}
                          </p>
                        )}
                        {res?.description && <p className="offer-description">{res.description}</p>}
                        {detail && (
                          <div className="offer-detail-image">
                            <img src={detail} alt="" />
                          </div>
                        )}
                        {!isEmpty(user) && (
                          <button
                            type="button"
                            className="view-all"
                            onClick={() => navigate(`/deposit/${res?._id}`)}
                          >
                            Deposit
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </LayoutNew>
  );
};

export default Promotions;
